import { Box, styled, Theme } from '@material-ui/core';

export const SocialButtonIconContainer = styled(Box)({
  position: 'absolute',
  left: 16,
  display: 'flex',
  alignItems: 'center',
});

export const getSocialButtonStyles = (theme: Theme) => ({
  textTransform: 'none' as const,
  borderRadius: 100,
  backgroundColor: theme.palette.grey[50],
  borderColor: theme.palette.divider,
  color: theme.palette.grey[800],
  position: 'relative' as const,
});
